import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import cn from "classnames";
import styles from "./tabs.module.css";

/**
 * Feed / Saved tabs. My Feed v3 (GROWTH-7573) puts them on the greeting's row and passes a
 * `className` to drop the bottom margin they keep on the Saved page.
 *
 * @param {Object} props
 * @param {string} [props.className]
 */
const Tabs = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.tabs, className)}>
      <NavLink to="/" className={({ isActive }) => cn(styles.tab, { [styles.tabsActive]: isActive })}>
        {t("dashboard_myfeed_secondary_nav_feed")}
      </NavLink>

      <NavLink to="/saved" className={({ isActive }) => cn(styles.tab, { [styles.tabsActive]: isActive })}>
        {t("dashboard_myfeed_secondary_nav_saved")}
      </NavLink>
    </div>
  );
};

export default Tabs;
